import { getTimezoneOffsetLabel } from './timezones';

export function formatInTimezone(
  iso: string | Date | null | undefined,
  timezone: string,
  options?: Intl.DateTimeFormatOptions
): string {
  if (!iso) return '—';
  const d = typeof iso === 'string' ? new Date(iso) : iso;
  if (Number.isNaN(d.getTime())) return '—';
  const tz = timezone?.trim() || 'UTC';
  try {
    return new Intl.DateTimeFormat(undefined, {
      dateStyle: 'medium',
      timeStyle: 'short',
      timeZone: tz,
      ...options,
    }).format(d);
  } catch {
    return d.toLocaleString();
  }
}

export function timezoneDisplayLabel(timezone: string): string {
  const tz = timezone?.trim() || 'UTC';
  try {
    return `${getTimezoneOffsetLabel(tz)} ${tz}`;
  } catch {
    return tz;
  }
}